import React from 'react';
import { TouchableOpacity } from 'react-native';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react-native';
import { Text, useThemeName } from '@tamagui/core';
import { XStack } from '@tamagui/stacks';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const themeName = useThemeName();

  const supportedOrder = ['pl', 'en', 'ru', 'ua'] as const;

  const getAvailable = () => {
    return supportedOrder.filter(code => i18n.hasResourceBundle(code, 'translation'));
  };

  const toggleLanguage = () => {
    const available = getAvailable();
    const current = i18n.language?.split('-')[0] || available[0];
    const idx = available.indexOf(current as (typeof available)[number]);
    const next = available[(idx + 1) % available.length];
    i18n.changeLanguage(next);
  };

  const getCurrentLanguageLabel = () => {
    return (i18n.language?.split('-')[0] || 'en').toUpperCase();
  };

  const backgroundColor = themeName === 'dark' ? '#374151' : '#f3f4f6';
  const borderColor = themeName === 'dark' ? '#4b5563' : '#d1d5db';
  const textColor = themeName === 'dark' ? '#ffffff' : '#374151';
  const iconColor = themeName === 'dark' ? '#60a5fa' : '#3b82f6';

  return (
    <TouchableOpacity onPress={toggleLanguage}>
      <XStack
        alignItems="center"
        paddingHorizontal="$3"
        paddingVertical="$2"
        borderRadius="$4"
        backgroundColor={backgroundColor}
        borderWidth={1}
        borderColor={borderColor}
        space="$2"
      >
        <Globe size={16} color={iconColor} />
        <Text fontSize="$3" color={textColor} fontWeight="600">
          {getCurrentLanguageLabel()}
        </Text>
      </XStack>
    </TouchableOpacity>
  );
};

export default LanguageSwitcher;
